import { Dispatch, SetStateAction, useState } from "react"
import { InputModel } from "../../../../../../utils/types"

export type InputValue = {
    input: Record<string, InputModel>
    setInput: Dispatch<SetStateAction<Record<string, InputModel>>>
}

export const inputMain = {
    search: {
        label: 'general.search',
        translate: true,
        name: 'search',
        type: 'text',
        value: null,
    },
    areas: {
        label: 'general.tags.area',
        translate: true,
        name: 'areas',
        type: 'filter-select',
        items: [],
        value: null,
        size: {
            xl: 12,
            lg: 12,
            md: 12,
            sm: 12,
        },
    },
    departments: {
        label: 'general.tags.department',
        translate: true,
        name: 'departments',
        type: 'filter-select',
        items: [],
        value: null,
        size: {
            xl: 12,
            lg: 12,
            md: 12,
            sm: 12,
        },
    },
} as Record<string, InputModel>

export const descriptionInput: Record<string, InputModel> = {
    register: {
        label: 'general.serviceTime.time.form.input.register',
        translate: true,
        name: 'register',
        type: 'text',
        value: null,
        validate: { required: true },
        rest: {
            inputProps: {
                maxLength: 255,
            },
        },
        size: {
            xl: 4,
            lg: 4,
            md: 4,
            sm: 4,
        },
    },
    description: {
        label: 'general.serviceTime.time.form.input.description',
        translate: true,
        name: 'description',
        type: 'text',
        value: null,
        //validate: { required: true },
        size: {
            xl: 8,
            lg: 8,
            md: 8,
            sm: 8,
        },
    },
}

export const raitingInput: Record<string, InputModel> = {
    areas: {
        label: 'general.serviceTime.time.form.input.area',
        translate: true,
        name: 'areas',
        type: 'select-search',
        items: [],
        value: null,
        validate: { required: true },
        size: {
            xl: 4,
            lg: 4,
            md: 4,
            sm: 4,
        },
    },
    departments: {
        label: 'general.serviceTime.time.form.input.department',
        translate: true,
        name: 'departments',
        type: 'select-search',
        items: [],
        value: null,
        validate: { required: true },
        size: {
            xl: 4,
            lg: 4,
            md: 4,
            sm: 4,
        },
    },
    section: {
        label: 'general.serviceTime.time.form.input.service',
        translate: true,
        name: 'section',
        type: 'filter-select',
        items: [],
        value: null,
        validate: { required: true },
        size: {
            xl: 4,
            lg: 4,
            md: 4,
            sm: 4,
        },
    },
}

export const formInputState = {
    description: descriptionInput,
    raiting: raitingInput
}

export const useInput = (): InputValue => {
    const [input, setInput] = useState<Record<string, InputModel>>(inputMain)
    return {
        input,
        setInput
    }
}